<template>
    <detail-header
        pretitle="Clients"
        :title="client ? client.name : '&nbsp;'"
        :editable="editable"
        :editMode="editMode"
        @editClick="onEditClick"
        @deleteClick="onDeleteClick"
        @saveClick="onSaveClick"
        @cancelClick="onCancelClick"
        @closeClick="$router.push('/admin/clients')"
        :customMode="isAccessByUserRole(btnRoles)"
        :customModeText="isEnabled"
        :customBtnClass="isEnabled=='Enable'?'btn btn-success':'btn btn-danger'"
        @customClick="onEnableDisableClient"
    />

    <div class="container-fluid">
        <Tabs :tabs="tabItems">
            <template v-slot:settings>
                <div class="row">
                    <div class="col-12">
                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>
                        <div
                            v-if="successMessage"
                            class="alert alert-success"
                            role="alert"
                        >
                            {{ successMessage }}
                        </div>
                        <div v-if="client" class="card mb-5">
                            <div class="card-body">
                                <form-fields
                                    :fields="autFields"
                                    v-model="client"
                                    :editMode="editMode"
                                />
                            </div>
                        </div>
                        <div v-else class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:settingsV2>
                <div class="row">
                    <div class="col-12">
                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>
                        <div
                            v-if="successMessage"
                            class="alert alert-success"
                            role="alert"
                        >
                            {{ successMessage }}
                        </div>
                        <div v-if="clientV2" class="card mb-5">
                            <div class="card-body">
                                <form-fields
                                    :fields="fieldsV2"
                                    v-model="clientV2"
                                    :editMode="editMode"
                                />
                            </div>
                        </div>
                        <div v-else class="text-center">
                            <h4 class="mt-4">No V2 settings detected for {{$route.params.id}}</h4>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:subscriptions>
                <div class="row" v-if="!loading">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-header-title">
                                    Subscriptions<span class="catalog-count">{{ clientProducts.length }}</span>
                                </h4>
                                <button class="btn btn-sm btn-primary"
                                    @click="showModal({ component: 'addClientSubscription' })"><i class="fa fa-plus me-1"></i>Add subscription</button>
                            </div>
                        <div @click="onSubscriptionTableClick">
                            <Datatable tableId="subscriptionTable" :columns="columns" uniqueField="product_id"
                                :data="clientProducts" :deletable="true" @deleteRows="showDeleteClientProducts" :compact="true"
                                :selectCheckboxes="true"
                                :formatColumn="formatColumn"
                                @viewModal="(data)=>showModal({ component: 'editClientSubscription',data:data})"
                                :detailColumn="{openModal:true}" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row">
                    <div class="col-md-12">
                        <div class="text-center mt-5">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            
        </Tabs>
    </div>
</template>

<script>
import DetailHeader from "../../components/DetailHeader.vue";
import autFields from "../../utils/field-constants/autClientEditFields";
import FieldsV2 from "../../utils/field-constants/clientV2EditFields";
import { mapActions } from "vuex";
import FormFields from "../../components/FormFields.vue";
import Tabs from "../../components/Tabs.vue";
import Datatable from "../../components/Datatable.vue";
import { codeCell, statusCell, productLinkCell } from "../../utils/catalogCells";
export default {
    name: "Client",
    components: { DetailHeader, FormFields, Tabs, Datatable },
    data() {
        var self=this;
        return {
            editMode: false,
            client: null,
            clientV2: null,
            snapshot: null,
            snapshotV2: null,
            error: "",
            successMessage: "",
            autFields: autFields,
            fieldsV2: FieldsV2,
            editable: true,
            tabItems: [{
                    name: "aUT Settings",
                    id: "id1",
                    slot: "settings",
                    onClick: function(){
                        self.$router.replace({ path:`/admin/clients/${self.$route.params.id}`,
                                                query: {settings: "details"}})
                    }
                },{
                    name: "Client Settings",
                    id: "id3",
                    slot: "settingsV2",
                    onClick: function(){
                        self.$router.replace({ path:`/admin/clients/${self.$route.params.id}/settingsV2`})
                    }
                },{
                    name: "Subscriptions",
                    id: "id2",
                    slot: "subscriptions",
                    onClick: function(){
                        self.$router.replace({ path:`/admin/clients/${self.$route.params.id}/subscriptions`});
                    }    
                }],
            columns:[
                { data: "product_id", title: "Product", render: (data, type, row) => (type === 'display' ? this.subscriptionProductCell(row) : this.subscriptionProduct(row)?.name || row.name || '') },
                { data: "sku", title:"Product SKU", render: codeCell },
                { data: "quantity"},
                { data: "effective_date", title: "Effective Date"},
                { data: "end_date", title: "End Date" },
                { data: "status", title: "Status", render: statusCell }
            ],
            formatColumn: [
                {
                    index: 5,
                    type: "date",
                },
                {
                    index: 6,
                    type: "date",
                },
            ], 
            loading:false,
            btnRoles: [ 1, 1.5 ] // granting aqfer_manager role to enable/disable client
        };
    },
    beforeMount() {
        this.fetchAUTClient();
        this.fetchClientV2();
        if( this.activeTab =='Subscriptions'){
            this.$router.replace({ path:`/admin/clients/${this.$route.params.id}/subscriptions`});
        }else if(this.$route.path.includes("subscriptions")){
            this.$store.dispatch('setActiveTab',"Subscriptions");
        }else if( this.activeTab =='Settings V2'){
            this.$router.replace({ path:`/admin/clients/${this.$route.params.id}/settingsV2`});
        }else if(this.$route.path.includes("settingsV2")){
            this.$store.dispatch('setActiveTab',"Settings V2");
        } else{
            this.$store.dispatch('setActiveTab',"aUT Settings");
        }
        this.$store.dispatch("aut/fetchPrivacyConfig",this.$route.params.id);
        this.fetchClientProducts(this.$route.params.id);
        if (!this.$store.state.admin.products.length)
            this.$store.dispatch("admin/fetchProducts");
    },
    computed:{
        activeTab(){
            return this.$store.state.activeTab
        },
        clientProducts(){
            void this.$store.state.admin.products.length;
            let activelist =this.$store.state.admin.clientProducts.map((sub)=>{
                let end_date =new Date(sub.end_date)
                sub.status = end_date> new Date() ? "Active": "Expired"
                return sub
            })
           return activelist
        },
        isEnabled(){
            return this.client?.enabled?"Disable":"Enable"
        },
        userRoleRank() {
            return this.$store.getters.userRoles.userRoleRank;
        }, 
    },
    watch: {
        "client": {
            handler: function(newData) {
                if(newData) { 
                    this.client.gpp.tcf.gvlId =   (this.client.gpp.tcf.status == "DISABLED"||this.client.gpp.tcf.gvlId == ''||this.client.gpp.tcf.gvlId == null)? null:Number(this.client.gpp.tcf.gvlId);                   
                    this.autFields = this.hideFields(this.autFields, newData);
                }                
            },
            deep: true       
        }, 
        "client.gpp.tcf.status":{
            handler: function(newData) {
                if(newData) { 
                    let flag = (newData == "ENABLED"); 
                    this.autFields.map((field)=>{
                        if(field.name === "gpp.tcf.mode" && flag){
                            field.visible = true;
                        }else if(field.name === "gpp.tcf.mode" ){
                            field.visible = false;
                            this.client.gpp.tcf.mode= null;
                        }
                    })
                }                
            },
            deep: true   
        },
        activeTab(newVal ) {
            this.client = JSON.parse(JSON.stringify(this.snapshot));
            this.clientV2 = JSON.parse(JSON.stringify(this.snapshotV2))
            this.setEditMode(false);
            this.editable=newVal=='Subscriptions'?false:true
        }

    },
    methods: {
        ...mapActions({
            readAUTClient: "admin/readAUTClient",
            updateAUTClient: "admin/updateAUTClient",
            enableDisableClient:"admin/enableDisableClient",
            deleteAUTClient: "admin/deleteAUTClient",
            readClientV2: "admin/readClientV2",
            updateClientV2: "admin/updateClientV2",
            deleteClientV2: "admin/deleteClientV2",
            showModal: "showModal",
            fetchClientProducts: "admin/fetchClientProducts"
        }),
        setEditMode(mode) {
            this.editMode = mode;
            this.successMessage = null;
            this.error = null;
        },
        async fetchAUTClient() {
            let response;
            try {
                response = await this.readAUTClient(this.$route.params.id);
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            }

            this.client = await response.data;
            this.client.eTag = response.headers['etag']
            this.snapshot = JSON.parse(JSON.stringify(this.client ));
        },
        async fetchClientV2() {
            let response;
            try {
                response = await this.readClientV2(this.$route.params.id);
            } catch (error) {
                console.log(error)
            }
            if (response) {
                this.clientV2 = await response.data;
                this.snapshotV2 = JSON.parse(JSON.stringify(this.clientV2));
            }
        },
        onCancelClick() {
            this.setEditMode(false);
            this.client = JSON.parse(JSON.stringify(this.snapshot ));
            this.clientV2 = JSON.parse(JSON.stringify(this.snapshotV2 ));
            this.error = null;
        },
        onEditClick() {
            this.setEditMode(true);
        },
        onDeleteClick() {
            const self = this;
            this.showModal({
                component: "confirm",
                data: {
                    title: "Delete Client",
                    message: `Are you sure you want to delete ${this.client.name}?`,
                    async confirm() {
                        try {
                            const aUTresponse = await self.deleteAUTClient(
                                self.client
                            );
                            const response = await self.deleteClientV2(
                                self.clientV2
                            );
                            self.$router.push("/admin/clients");
                            return response;
                        } catch (error) {
                            if (error.response.data.error)
                                self.error = error.response.data.error;
                            else self.error = error.message;
                            return;
                        }
                    },
                },
            });
        },
        hideFields(fields, obj) {
            return fields.map((field) => {
                if(field.suppressIfField) {    
                    const val = field.suppressIfField.split('.').reduce((o, i) => o[i], obj);
                    if(field.suppressIfValueContains && field.suppressIfValueContains.indexOf(val) > -1)
                        field.visible = false;
                    else if(field.suppressIfValueDoesNotContains && field.suppressIfValueDoesNotContains.indexOf(val) == -1)
                        field.visible = false;    
                    else
                        field.visible = true;

                    return field;   
                    
                }
                if(field.name ==="classLimit" || field.name ==="datastream.enabled"){
                    field.visible = this.userRoleRank <= 2 ? true : false;
                    field.editable = this.userRoleRank <= 2 ? true : false;
                }                   
                    
                return field;
            }); 
        },
        async onSaveClick() {
            let self = this;
            let clientObj = this.client;    
            if( this.activeTab === "aUT Settings"){  
                try {
                    await this.updateAUTClient(clientObj).then(async ()=>{
                        this.setEditMode(false);
                        this.successMessage = "aUT Settings updated successfully.";
                        // fetch client again to reset the eTag before further edits can be made
                        await this.fetchAUTClient();
                    })
                } catch (error) {
                    if (error.response.data.error)
                        self.error = error.response.data.error;
                    else self.error = error.message;
                }
            }
            if(this.clientV2 && this.activeTab === "Client Settings") {
                try {
                    await this.updateClientV2(this.clientV2).then(()=>{
                        this.setEditMode(false);
                        this.successMessage = "Client settings updated successfully.";
                        this.snapshotV2 = JSON.parse(JSON.stringify(this.clientV2));
                    });
                } catch (error) {
                    if (error.response.data.error)
                        self.error = error.response.data.error;
                    else self.error = error.message;
                }
            }
        },
        subscriptionProduct(row) {
            return this.$store.state.admin.products.find((item) => item.product_id === row.product_id);
        },
        subscriptionProductCell(row) {
            const product = this.subscriptionProduct(row);
            return productLinkCell(product, product ? `/admin/products/${encodeURIComponent(product.name)}/versions/${product.version}` : null, row.name);
        },
        onSubscriptionTableClick(event) {
            const link = event.target.closest("a[data-route]");
            if (link) {
                event.preventDefault();
                this.$router.push(link.getAttribute("data-route"));
            }
        },
        showDeleteClientProducts(rows) {
            this.showModal({ component: "deleteClientProducts", data: rows });
        },
        async onEnableDisableClient() {
            var self= this;
            let clientObj = this.client;
            let toastoptions;
            this.showModal({
                component: "confirm",
                data: {
                    title:`${this.isEnabled} Client`,
                    message: `Are you sure you want to ${this.isEnabled.toLowerCase()} client ${this.client.cid}?`,
                    async confirm() {
                        try {
                            let msg = clientObj.enabled ?"Disabled" :"Enabled"
                            clientObj.enabled=!clientObj.enabled
                            await self.enableDisableClient(clientObj).then(()=>{
                                self.enabled=!clientObj.enabled;
                            });
                            toastoptions = {
                                message: `${msg} client successfully.`,
                                type: "success"
                            }
                            await self.fetchAUTClient();
                        } catch (error) {
                            if (error.response.data.error)
                                self.error = error.response.data.error;
                            else self.error = error.message;
                            toastoptions = {
                                message: self.error || `Something went wrong. Please contact support.`,
                                type: "error",
                            };
                        } finally{
                            self.$store.dispatch('addToast', toastoptions);
                        }
                    },
                },
            });
            
        },
        isAccessByUserRole(roles) {
            return this.$store.getters.userRoles.isAccessByRole(roles);
        }
    },
};
</script>

<style>
</style>